import React from "react";
import CoursesRequestforAdmin from "../../../components/CoursesRequestforAdmin/CoursesRequestforAdmin";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useDispatch } from "react-redux";
import {
  getPendingApprovalCoursesAPI,
  getPendingUnpublishCoursesAPI,
} from "../../../redux/features/adminSlice";
import AdminNotification from "../../../components/Notification/AdminNotification";
import CoursesUnpublishRequestforAdmin from "../../../components/CoursesUnpublishRequestforAdmin/CoursesUnpublishRequestforAdmin";
const RequestCoursesAdmin = () => {
  const dispatch = useDispatch();

  const fetchPendingApprovalCourses = async (token) => {
    return await dispatch(getPendingApprovalCoursesAPI({ token })).unwrap();
  };

  const fetchPendingUnpublishCourses = async (token) => {
    return await dispatch(getPendingUnpublishCoursesAPI({ token })).unwrap();
  };

  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3 className="ad-heading-04 fw-bold mb-8">
            Courses Creation Requests
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <AdminNotification />
          </div>
        </div>
      </div>
      <div className="card-default-style px-14 py-40">
        <CoursesRequestforAdmin
          fetchApi={fetchPendingApprovalCourses}
          isCourseTable={true}
        />
      </div>
      <hr className="mt-40" />
      <h3 className="ad-heading-04 fw-bold my-40">Courses Unpublish Request</h3>
      <div className="card-default-style px-14 py-40">
        <CoursesUnpublishRequestforAdmin
          fetchApi={fetchPendingUnpublishCourses}
          isCourseTable={true}
        />
      </div>
    </>
  );
};

export default RequestCoursesAdmin;
